var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-modal-manager"},[_vm._l((_vm.modals),function(modal){return [_c(modal.component,{key:((modal.name) + "-" + (modal.id)),tag:"component",attrs:{"modal":{ id: modal.id, name: modal.name }}})]})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586adbd8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/app/plugins/modals/ModalManager.vue
// module id = 270
// module chunks = 65